import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { Component, useState, useEffect } from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './VehicleMenu.css';

var MenuItem = function MenuItem(_ref) {
  var text = _ref.text,
      activeItem = _ref.activeItem,
      iconPath = _ref.iconPath;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "vehiclemenu-item ".concat(activeItem == text.toLowerCase() ? "active" : "")
  }, /*#__PURE__*/React.createElement("img", {
    className: "menu-image",
    src: iconPath
  }), /*#__PURE__*/React.createElement("div", null, text)));
};

var LeftArrow = function LeftArrow(_ref2) {
  var size = _ref2.size;
  return /*#__PURE__*/React.createElement(FiChevronLeft, {
    size: size
  });
};

var RightArrow = function RightArrow(_ref3) {
  var size = _ref3.size;
  return /*#__PURE__*/React.createElement(FiChevronRight, {
    size: size
  });
};

var Menu = function Menu(vehicleList, activeItem) {
  return vehicleList === null || vehicleList === void 0 ? void 0 : vehicleList.map(function (el) {
    var name = el.name,
        iconPath = el.iconPath;
    return /*#__PURE__*/React.createElement(MenuItem, {
      text: name,
      iconPath: iconPath,
      key: name,
      activeItem: activeItem
    });
  });
};

var ArrowLeft = LeftArrow({
  size: '2em'
});
var ArrowRight = RightArrow({
  size: '2em'
});
export var VehicleMenu = function VehicleMenu(props) {
  var _useState = useState(props === null || props === void 0 ? void 0 : props.activeItem),
      _useState2 = _slicedToArray(_useState, 2),
      activeItem = _useState2[0],
      setActiveItem = _useState2[1];

  useEffect(function () {}, [activeItem]);

  var handleChange = function handleChange(e) {
    props.onchange(e);
  };

  var vehicleList = props === null || props === void 0 ? void 0 : props.vehicleList;
  var menuItems = Menu(vehicleList, activeItem);
  return /*#__PURE__*/React.createElement("div", {
    className: "horizontal-vehiclemenu",
    style: {
      paddingTop: props.paddingTop
    }
  }, /*#__PURE__*/React.createElement(ScrollMenu, {
    data: menuItems,
    scrollBy: 0,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    alignCenter: false,
    hideSingleArrow: false,
    scrollToSelected: true,
    selected: activeItem,
    disableTabindex: true,
    onSelect: function onSelect(item) {
      setActiveItem(item === null || item === void 0 ? void 0 : item.toLowerCase());
      handleChange(item);
    },
    useButtonRole: false
  }));
};